import type { ValueOf } from '@weft/utils';
import { parseJson, oz } from '@weft/utils';

export const APPROVAL_FLOW_INVOICE_TYPES = Object.freeze({
  PREVIOUS_CYCLE: 'previousCycle',
  OLD_CYCLES: 'oldCycles',
  OVERAGES: 'overages',
});

export type ApprovalFlowInvoiceTypes = ValueOf<typeof APPROVAL_FLOW_INVOICE_TYPES>;

export const ApprovalFlowInvoiceTypesParamSchema = oz.string()
  .transform(s => parseJson<ApprovalFlowInvoiceTypes[]>(s))
  .pipe(oz.nativeEnum(APPROVAL_FLOW_INVOICE_TYPES).array())
  .openapi('ApprovalFlowInvoiceType');

export type ApprovalFlowInvoiceTypesParam = oz.infer<typeof ApprovalFlowInvoiceTypesParamSchema>;